<script setup lang="ts">
import { PHeader, PLayout } from '@previo/design-system'
import { Color } from '@previo/codebooks'
import { onBeforeMount } from 'vue'
import { useFeatureFlags } from '@previo/feature-flags'
import AppMenu from '~/layouts/components/app-menu/AppMenu.vue'
import PageLoader from '~/layouts/components/PageLoader.vue'
import ModuleSetting from '~/layouts/components/setting-modules/ModuleSetting.vue'

onBeforeMount(async () => {
  await useFeatureFlags().waitForInit()
})
</script>

<template>
  <p-layout :color="Color.GREY_100">
    <p-header>
      <app-menu />
    </p-header>

    <suspense>
      <template #default>
        <module-setting />
      </template>

      <template #fallback>
        <page-loader />
      </template>
    </suspense>
  </p-layout>
</template>
